'use client';

import classNames from 'classnames';

import { ArticleCardBig } from '~components/ArticleCardBig/ArticleCardBig';
import { Section } from '~components/Section/Section';
import { HeaderSection } from '~containers/MainPage/HeaderSection/HeaderSection';
import { ArticleCardImagePosition } from '~types/Article.types';

import styles from './Section2Cards.module.scss';
import { Section2CardsProps } from './Section2Cards.types';

const ARTICLES_COUNT = 2;

export function Section2Cards({
  title,
  titleBacklight,
  articles,
  category,
  ...sectionProps
}: Section2CardsProps) {
  if (!articles.length) return null;

  const featuredArticles = articles.slice(0, ARTICLES_COUNT);

  return (
    <Section className={classNames(styles.section)} {...sectionProps}>
      {title && (
        <HeaderSection
          title={title}
          titleBacklight={titleBacklight}
          href={category.href}
          countArticles={category.count}
          hasPageCategory={!!category.href}
        />
      )}
      <div className={classNames(styles.articles)}>
        {featuredArticles.map((article, key) => (
          <ArticleCardBig
            key={article.id}
            className={styles.article}
            imagePosition={
              key === 1
                ? ArticleCardImagePosition.Top
                : ArticleCardImagePosition.Bottom
            }
            {...article}
            categories={[category]}
          />
        ))}
      </div>
    </Section>
  );
}
